import $ from 'jquery';
import _ from 'lodash';

const constants = {
    EVENT_RESPONSIVE_BREAKPOINT_CHANGE: 'ResponsiveBreakpointChange',
    SCREEN_WIDTH_SMALL: 'small',
    SCREEN_WIDTH_MEDIUM: 'medium',
    SCREEN_WIDTH_LARGE: 'large',
    SCREEN_WIDTH_XLARGE: 'xlarge',

    MEDIA_MATCH_SMALL: '(max-width:  767px)',
    MEDIA_MATCH_MEDIUM: '(min-width: 768px) and (max-width: 991px)',
    MEDIA_MATCH_LARGE: '(min-width: 992px) and (max-width: 1279px)',
    MEDIA_MATCH_XLARGE: '(min-width: 1280px)',
};

let responsiveWidthChangeCallbacks = [];
let resizeCallbacks = [];

const points = {
    small: window.matchMedia(`only screen and ${constants.MEDIA_MATCH_SMALL}`),
    medium: window.matchMedia(`only screen and ${constants.MEDIA_MATCH_MEDIUM}`),
    large: window.matchMedia(`only screen and ${constants.MEDIA_MATCH_LARGE}`),
    xlarge: window.matchMedia(`only screen and ${constants.MEDIA_MATCH_XLARGE}`),
};

let oldWidth;
let responsiveService = {};

function propagateEventToRegisteredCallbacks(currentWidth) {
    responsiveWidthChangeCallbacks.forEach(function (callback) {
        callback(currentWidth);
    });
}

function widthChange(mq) {
    var current;

    if (mq.matches) {
        current = responsiveService.getCurrent();

        if (oldWidth !== current) {
            propagateEventToRegisteredCallbacks(current);
            oldWidth = current;
        }
    }
}

responsiveService.getCurrent = function () {
    var found = constants.SCREEN_WIDTH_SMALL;

    $.each(points, function (size, mq) {
        if (mq.matches) {
            found = size;
        }
    });

    return found;
};

responsiveService.registerOnChangeCallback = function (callback) {
    responsiveWidthChangeCallbacks.push(callback);
    return () => {
        responsiveWidthChangeCallbacks = responsiveWidthChangeCallbacks.filter((cb) => cb !== callback);
    };
};

responsiveService.registerOnResizeCallback = function (callback) {
    resizeCallbacks.push(callback);
    return () => {
        resizeCallbacks = resizeCallbacks.filter((cb) => cb !== callback);
    };
};

$(window).on('resize', _.debounce(function () {
    resizeCallbacks.forEach(function (callback) {
        callback();
    });
}, 250));

$.each(points, function (size, mq) {
    mq.addListener(widthChange);
});

responsiveService = $.extend(responsiveService, constants);

export default responsiveService;

